import CustomAddRemoveItemsModal from "../../../../components/AddRemoveItemsModal/CustomAddRemoveItemsModal";
import {ManageAuthorizedEmployeeApp} from "../Funtionality/ManageAuthorizedEmployeeApp";
import {TABLES} from "../../../../Apis/Tables";
import {userListToLabelEmailPhoneValue} from "../../../../Apis/functions";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const ManageAuthorizedEmployeeModal = ({show, onHide, selectedId, setModified, modified }) => {
    const { handleDelete, handleAdd, selectedEmployee } = ManageAuthorizedEmployeeApp({
        onHide,
        selectedId,
        setModified,
        modified
    });

    return (
        <CustomAddRemoveItemsModal
            show={show}
            onHide={onHide}
            selected={selectedEmployee}
            handleDelete={handleDelete}
            handleAdd={handleAdd}
            option={TABLES.USER_NOT_ASSIGNED_TO_ZONE}
            modelId={selectedId}
            listTransform={userListToLabelEmailPhoneValue}
        />
    );
};

export default ManageAuthorizedEmployeeModal;
